/* istanbul ignore file */
import React from 'react';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleProjectWeeklyReportBreadcrumbs from 'domain/projects/project/weeklyreports/shared/SingleProjectWeeklyReportBreadcrumbs';

const UpdateProjectWeeklyReportBreadcrumbs = () => {
  return (
    <SingleProjectWeeklyReportBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleProjectWeeklyReportBreadcrumbs>
  );
};

export default UpdateProjectWeeklyReportBreadcrumbs;
